/**
 * Dadaş Auto — iyzico taksit tablosu.
 *
 * Varyant değiştiğinde (Horizon `variant:update` olayı) tablodaki aylık/toplam
 * tutarları ve özet satırını yeni fiyata göre yeniden hesaplar.
 * Tutarlar mağazanın para birimi biçimiyle (shop.money_format) yazılır ki
 * sayfadaki diğer fiyatlarla aynı görünsün.
 */
(function () {
  if (window.__dadasInstallments) return;
  window.__dadasInstallments = true;

  var GROUP = /\B(?=(\d{3})+(?!\d))/g;

  function separate(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    var whole = parts[0].replace(GROUP, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;

    return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, name) {
      switch (name) {
        case 'amount':
          return separate(value, 2, ',', '.');
        case 'amount_no_decimals':
          return separate(Math.round(value), 0, ',', '.');
        case 'amount_with_comma_separator':
          return separate(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return separate(Math.round(value), 0, '.', ',');
        case 'amount_with_space_separator':
          return separate(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return separate(Math.round(value), 0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return separate(value, 2, "'", '.');
        default:
          return '';
      }
    });
  }

  function totalCents(priceCents, ratePercent) {
    return Math.round(priceCents * (1 + ratePercent / 100));
  }

  function update(root, priceCents) {
    var format = root.getAttribute('data-money-format');
    var rows = root.querySelectorAll('tbody tr[data-n]');
    var lowest = 0;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var count = parseInt(row.getAttribute('data-n'), 10) || 1;
      var rate = parseFloat(row.getAttribute('data-rate')) || 0;
      var total = count === 1 ? priceCents : totalCents(priceCents, rate);
      var monthly = count === 1 ? priceCents : Math.round(total / count);

      var monthlyCell = row.querySelector('[data-cell="monthly"]');
      var totalCell = row.querySelector('[data-cell="total"]');
      if (monthlyCell) monthlyCell.textContent = formatMoney(monthly, format);
      if (totalCell) totalCell.textContent = formatMoney(total, format);

      if (count > 1 && (lowest === 0 || monthly < lowest)) lowest = monthly;
    }

    var teaser = root.querySelector('[data-cell="teaser"]');
    if (teaser && lowest > 0) teaser.textContent = formatMoney(lowest, format);

    root.setAttribute('data-price', String(priceCents));
  }

  document.addEventListener('variant:update', function (event) {
    var price = event && event.detail && event.detail.resource && event.detail.resource.price;
    if (typeof price !== 'number') return;

    var blocks = document.querySelectorAll('.dadas-inst[data-money-format]');
    for (var i = 0; i < blocks.length; i++) update(blocks[i], price);
  });
})();
